import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { SelectBox } from 'cbc-shared-lib';
import { Sgke321aResponseWorkTntsh, Sgke322aResponseSearchresultHyojiInfo, Sgke322aResponseSearchresultList } from 'sg-api';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke320d-result',
  templateUrl: './sgke320d-result.component.html',
  styleUrl: './sgke320d-result.component.scss'
})
export class Sgke320dResultComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  /** 作業担当者 */
  @Input() workTntshList: Array<Sgke321aResponseWorkTntsh>;
  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke322aResponseSearchresultList>;
  /** 検索結果表示情報 */
  @Input() searchresultHyojiInfo: Sgke322aResponseSearchresultHyojiInfo;
  /** 登録ボタン押下イベント */
  @Output() onClickRegistEvent = new EventEmitter();

  /** データソース */
  dataSource: MatTableDataSource<any>;
  /** 選択した行の情報 */
  selection: SelectionModel<Sgke322aResponseSearchresultList> = new SelectionModel<Sgke322aResponseSearchresultList>(true, []);
  /** ソート */
  @ViewChild('sort1', { static: true }) sort!: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator!: MatPaginator;

  /** 停止種別コードリスト(S300380) */
  lpwaMethodList: SelectBox[] = [];

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'stpClsfy',
    'base',
    'tntsh',
    'suppntSpno',
    'sougouHisougou.aname',
    'parentChild.aname',
    'supplydestinationAddr',
    'gastype.aname',
    'errorStr',
    'supplystopResumeSts.aname',
    'forcedsuspensionTargetflag',
    'supplystopBreakPlndate',
    'payCtrNo',
    'visitName',
  ];

  /**
   * コンストラクタ
   * @param {ChangeDetectorRef} cd
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke320dResultComponent
   */
  constructor(
    private cd: ChangeDetectorRef,
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke320dResultComponent
   */
  ngOnInit(): void {

    // 停止種別リスト作成
    this.lpwaMethodList.push(...this.getlpwaMethodSelector('codeValue', 'aname'));

    // "SGKE322A検索結果"に拠点に紐づく作業担当者リストを追加
    let extendedSearchresultList = this.searchresultList.map(row => ({
      ...row,
      tntshList: this.tntshListCreate(row.base)
    }))

    // 停止種別リスト、作業担当者リストの初期表示値に異常値が入らないようガード
    extendedSearchresultList.forEach(row => (
      row.stpClsfy.codeValue = this.listSearchUtils.getListboxValue(row.stpClsfy.codeValue, this.lpwaMethodList) ?? null,
      row.tntsh.codeValue = this.listSearchUtils.getListboxValue(row.tntsh.codeValue, row.tntshList) ?? null
    ))

    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke322aResponseSearchresultList>(extendedSearchresultList);


    this.dataSource.sortingDataAccessor = (item, property) => {
      return property
        .split('.')
        .reduce((acc, key) => acc?.[key], item);
    };

    this.cd.detectChanges();
  }

  /**
   * 購読解除
   * @memberof Sgke320dResultComponent
   */
  ngOnDestroy() {
  }

  /**
   * 画面描画後初回処理
   * @memberof Sgke320dResultComponent
   */
  ngAfterViewInit() {
    // 表データとソートを連携
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 画面描画後処理
   * @memberof Sgke320dResultComponent
   */
  ngAfterViewChecked() {
    // 表データと、ソート/ページングを連携
    if (this.dataSource) {
      this.dataSource.paginator ??= this.paginator;
    }
  }

  /**
   * 全選択チェック
   * @readonly
   * @memberof Sgke320dResultComponent
   */
  get isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * 拠点に紐づく担当者リスト作成
   * @param {string} base
   * @return {*}  {SelectBox[]}
   * @memberof Sgke320dResultComponent
   */
  tntshListCreate(base: string): SelectBox[] {
    return this.workTntshList
      .filter(list => list.base == base)
      .map(data => {
        const select: SelectBox = { value: data.staffCode, viewValue: data.staffKanjiName };
        return (select);
      });
  };

  /**
   * SGKE322Aレスポンスからセレクターにオプションをセット
   * @param {string} value
   * @param {string} viewValue
   * @return {*}  {SelectBox[]}
   * @memberof Sgke320dResultComponent
   */
  getlpwaMethodSelector(value: string, viewValue: string): SelectBox[] {

    // SGKE322Aレスポンスのコードとコード値をまとめてリスト化
    let retSelectBoxList = this.searchresultHyojiInfo.stpClsfyList
      .map(data => {
        return { value: data[value], viewValue: data[viewValue] };
      })
      .reduce<SelectBox[]>((result, curr) => {
        const select = { value: curr[value], viewValue: curr[viewValue] }
        // 既に抽出済みでないものを追加
        if (!result.some((row) => row.value == curr.value)) {
          result.push(curr);
        }
        return result;
      }, [] as SelectBox[])
      .sort((a, b) => a.value > b.value ? 1 : -1);

    return retSelectBoxList;

  }

  /**
   * 全選択ボタン押下時処理
   * @memberof Sgke320dResultComponent
   */
  masterToggle() {
    this.isAllSelected ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /**
   * 登録ボタン押下時処理
   * @memberof Sgke320dResultComponent
   */
  onClickRegist() {
    this.onClickRegistEvent.emit(this.selection.selected);
  }

  /**
   * 停止種別選択時処理
   * @param {*} row
   * @memberof Sgke320dResultComponent
   */
  onChangelpwaMethod(row) {
    row.tntsh.codeValue = null;
  }

}

